<ng-container *ngIf="shouldShowErrors()">
    <div *ngFor="let error of listOfErrors()" [innerHTML]="error" class="invalid-feedback"></div>
</ng-container>
